import React from 'react';

/** Shown while a lazy-loaded route chunk is downloading */
export default function RoutePageFallback() {
    return (
        <div className="route-page-fallback text-center" style={{ padding: '64px 16px' }}>
            <p className="text-muted" style={{ marginBottom: 0 }}>
                <i className="fa fa-spinner fa-spin fa-2x" aria-hidden="true" />
            </p>
            <p className="text-muted" style={{ marginTop: 16 }}>
                Loading page…
            </p>
        </div>
    );
}
